module.exports = __webpack_public_path__ + "static/media/basement-stairs.e614dc7b.jpg";